import { defineComponent as _defineComponent } from 'vue'
import { Client, Wallet } from 'ah-api-gateways';
import { RequestState } from 'ah-requests';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';
import { ON_BEHALF_OF_CLIENT_INJECT_KEY } from 'ah-common-lib/src/onBehalfOf/constants';
import { inject, reactive, watch } from 'vue';
import { useAhWalletsState } from '..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';


export default /*#__PURE__*/_defineComponent({
  __name: 'WalletTransferText',
  props: {
    destinationCurrency: { default: '' },
    destinationAmount: { default: 0 }
  },
  setup(__props: any) {

const props = __props as { destinationCurrency: string, destinationAmount: number };

const walletState = useAhWalletsState();

const requestManager = useRequestManager();



const state = reactive<{
  onBehalfOfClient: Client | null;
  destinationWallet: Wallet | null;
  destinationWalletLoadState: RequestState;
}>({
  onBehalfOfClient: inject(ON_BEHALF_OF_CLIENT_INJECT_KEY, null),
  destinationWallet: null,
  destinationWalletLoadState: 'idle',
});

watch(
  () => props.destinationCurrency,
  (newVal?: string, oldVal?: string) => {
    if (newVal && newVal !== oldVal) {
      requestManager.manager
        .newPromise(
          'destinationWalletLoadState',
          walletState.store.useWalletsStore().loadCurrencyWallet({
            currency: newVal,
            owner: state.onBehalfOfClient ? { isPartner: false, id: state.onBehalfOfClient.id } : undefined,
          })
        )
        .then((wallet) => {
          state.destinationWallet = wallet || null;
        });
    }
  },
  { immediate: true }
);

return { __sfc: true,walletState, requestManager, props, state, formatCurrencyValue }
}

})